var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#FFF2F5",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FFF2F5",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40249 6.88325C7.40249 6.59635 7.63507 6.36377 7.92197 6.36377L13.1168 6.36377C13.2545 6.36377 13.3867 6.4185 13.4841 6.51592C13.5815 6.61334 13.6363 6.74548 13.6363 6.88325L13.6363 12.0781C13.6363 12.365 13.4037 12.5975 13.1168 12.5975C12.8299 12.5975 12.5973 12.365 12.5973 12.0781L12.5973 8.13739L7.25033 13.4843C7.04746 13.6872 6.71855 13.6872 6.51568 13.4843C6.31281 13.2815 6.31281 12.9526 6.51568 12.7497L11.8626 7.40273L7.92197 7.40273C7.63507 7.40273 7.40249 7.17015 7.40249 6.88325Z",
    fill: "#D65656",
    stroke: "#D65656",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.b6cc3b4dc84439d656c6f91f0d0b0ed6.svg";
export { ForwardRef as ReactComponent };